import { ApolloLink } from '@apollo/client'

import { getAccessToken } from 'Services/Store/Modules/auth'

export default function createAuthLink() {
  return new ApolloLink((operation, forward) => {
    operation.setContext(({ headers = {} }) => {
      const accessToken = getAccessToken()

      return {
        headers: {
          ...headers,
          Authorization: accessToken ? `Bearer ${accessToken}` : null,
        },
      }
    })

    return forward(operation)
  })
}
